const API_BASE_URL = process.env.REACT_APP_API_URL || "https://srinivasafleet.com/api";

export async function askChatbot(question) {
  const token = localStorage.getItem("token"); 

  const response = await fetch(`${API_BASE_URL}/Chatbot/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ question }),
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Your session has expired. Please log in again.");
    }
    throw new Error(`Chatbot request failed (${response.status})`);
  }

  return response.json(); // { answer, sql_used, row_count, raw_rows }
}